import { SCREEN_SIZE_QUERY, SCREEN_TYPE } from '@constants/common.constants';

const isMatchQuery = (screenSize: SCREEN_TYPE): boolean => {
	const media = window.matchMedia(SCREEN_SIZE_QUERY[screenSize]);
	return media.matches;
};

export const isDesktopSize = () => isMatchQuery(SCREEN_TYPE.DESKTOP);
export const isTabletSize = () => isMatchQuery(SCREEN_TYPE.TABLET);
export const isMobileSize = () => isMatchQuery(SCREEN_TYPE.MOBILE);

export const detectScreenType = () => {
	if (isDesktopSize()) {
		return SCREEN_TYPE.DESKTOP;
	}
	if (isTabletSize()) {
		return SCREEN_TYPE.TABLET;
	}
	if (isMobileSize()) {
		return SCREEN_TYPE.MOBILE;
	}
}